/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApproveUserRequest,
  CreateUserGroup201Response,
  CreateUserGroupAssignment201Response,
  FindAllUserDynamicPermissions200Response,
  FindAllUserFacilityAccess200Response,
  FindAllUserGroups200Response,
  FindAllUsersV2200Response,
  FindOneUser200Response,
  GetCurrentUser200Response,
  GetMentionSuggestions200Response,
  GetOrganizationMfaSettings200Response,
  RecordMentionUsageRequest,
  SetUserDynamicPermissionsRequest,
  UpdateCurrentUserHospitalChatSignature200Response,
  UpdateCurrentUserHospitalChatSignatureRequest,
  UpdateCurrentUserPylonUnreadBaseline200Response,
  UpdateCurrentUserPylonUnreadBaselineRequest,
  UpdateOrganizationMfaSettingsRequest,
  UpdateUserFacilityAccessRequest,
  UserCrmNotificationStatus,
  UserGroup,
  UserGroupAssignment,
} from '../models/index';
import {
    ApproveUserRequestFromJSON,
    ApproveUserRequestToJSON,
    CreateUserGroup201ResponseFromJSON,
    CreateUserGroup201ResponseToJSON,
    CreateUserGroupAssignment201ResponseFromJSON,
    CreateUserGroupAssignment201ResponseToJSON,
    FindAllUserDynamicPermissions200ResponseFromJSON,
    FindAllUserDynamicPermissions200ResponseToJSON,
    FindAllUserFacilityAccess200ResponseFromJSON,
    FindAllUserFacilityAccess200ResponseToJSON,
    FindAllUserGroups200ResponseFromJSON,
    FindAllUserGroups200ResponseToJSON,
    FindAllUsersV2200ResponseFromJSON,
    FindAllUsersV2200ResponseToJSON,
    FindOneUser200ResponseFromJSON,
    FindOneUser200ResponseToJSON,
    GetCurrentUser200ResponseFromJSON,
    GetCurrentUser200ResponseToJSON,
    GetMentionSuggestions200ResponseFromJSON,
    GetMentionSuggestions200ResponseToJSON,
    GetOrganizationMfaSettings200ResponseFromJSON,
    GetOrganizationMfaSettings200ResponseToJSON,
    RecordMentionUsageRequestFromJSON,
    RecordMentionUsageRequestToJSON,
    SetUserDynamicPermissionsRequestFromJSON,
    SetUserDynamicPermissionsRequestToJSON,
    UpdateCurrentUserHospitalChatSignature200ResponseFromJSON,
    UpdateCurrentUserHospitalChatSignature200ResponseToJSON,
    UpdateCurrentUserHospitalChatSignatureRequestFromJSON,
    UpdateCurrentUserHospitalChatSignatureRequestToJSON,
    UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSON,
    UpdateCurrentUserPylonUnreadBaseline200ResponseToJSON,
    UpdateCurrentUserPylonUnreadBaselineRequestFromJSON,
    UpdateCurrentUserPylonUnreadBaselineRequestToJSON,
    UpdateOrganizationMfaSettingsRequestFromJSON,
    UpdateOrganizationMfaSettingsRequestToJSON,
    UpdateUserFacilityAccessRequestFromJSON,
    UpdateUserFacilityAccessRequestToJSON,
    UserCrmNotificationStatusFromJSON,
    UserCrmNotificationStatusToJSON,
    UserGroupFromJSON,
    UserGroupToJSON,
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentToJSON,
} from '../models/index';

export interface ApproveSsoUserRequest {
    id: string;
    approveUserRequest: ApproveUserRequest;
}

export interface CreateUserGroupRequest {
    userGroup: UserGroup;
}

export interface CreateUserGroupAssignmentRequest {
    userGroupAssignment: UserGroupAssignment;
}

export interface DeleteUserRequest {
    id: string;
    newTaskUserId?: string;
    newProspectUserId?: string;
}

export interface DeleteUserGroupRequest {
    id: string;
}

export interface DeleteUserGroupAssignmentRequest {
    id: string;
}

export interface FindAllUserDynamicPermissionsRequest {
    id: string;
}

export interface FindAllUserFacilityAccessRequest {
    id: string;
}

export interface FindAllUserGroupsRequest {
    facilityId?: string;
}

export interface FindAllUsersV2Request {
    page?: number;
    limit?: number;
    facilityIds?: string;
    userTypeIds?: string;
    name?: string;
    statuses?: string;
    userId?: string;
}

export interface FindOneUserRequest {
    id: string;
    includeDeleted?: string;
}

export interface FindOneUserGroupRequest {
    id: string;
    facilityId?: string;
}

export interface GetMentionSuggestionsRequest {
    facilityId: string;
    query?: string;
    page?: number;
    limit?: number;
}

export interface RecordMentionUsageOperationRequest {
    recordMentionUsageRequest: RecordMentionUsageRequest;
}

export interface RejectSsoUserRequest {
    id: string;
}

export interface SetUserDynamicPermissionsOperationRequest {
    id: string;
    setUserDynamicPermissionsRequest: SetUserDynamicPermissionsRequest;
}

export interface UpdateCurrentUserHospitalChatSignatureOperationRequest {
    updateCurrentUserHospitalChatSignatureRequest: UpdateCurrentUserHospitalChatSignatureRequest;
}

export interface UpdateCurrentUserPylonUnreadBaselineOperationRequest {
    updateCurrentUserPylonUnreadBaselineRequest: UpdateCurrentUserPylonUnreadBaselineRequest;
}

export interface UpdateOrganizationMfaSettingsOperationRequest {
    updateOrganizationMfaSettingsRequest: UpdateOrganizationMfaSettingsRequest;
}

export interface UpdateUserCrmNotificationStatusRequest {
    id: string;
    userCrmNotificationStatus: UserCrmNotificationStatus;
}

export interface UpdateUserFacilityAccessOperationRequest {
    id: string;
    updateUserFacilityAccessRequest: UpdateUserFacilityAccessRequest;
}

export interface UpdateUserGroupRequest {
    id: string;
    userGroup: UserGroup;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Approve SSO user
     */
    async approveSsoUserRaw(requestParameters: ApproveSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling approveSsoUser.');
        }

        if (requestParameters.approveUserRequest === null || requestParameters.approveUserRequest === undefined) {
            throw new runtime.RequiredError('approveUserRequest','Required parameter requestParameters.approveUserRequest was null or undefined when calling approveSsoUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveUserRequestToJSON(requestParameters.approveUserRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve SSO user
     */
    async approveSsoUser(requestParameters: ApproveSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveSsoUserRaw(requestParameters, initOverrides);
    }

    /**
     * Create a user group
     */
    async createUserGroupRaw(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.userGroup === null || requestParameters.userGroup === undefined) {
            throw new runtime.RequiredError('userGroup','Required parameter requestParameters.userGroup was null or undefined when calling createUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters.userGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group
     */
    async createUserGroup(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.createUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignmentRaw(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroupAssignment201Response>> {
        if (requestParameters.userGroupAssignment === null || requestParameters.userGroupAssignment === undefined) {
            throw new runtime.RequiredError('userGroupAssignment','Required parameter requestParameters.userGroupAssignment was null or undefined when calling createUserGroupAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-group-assignments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentToJSON(requestParameters.userGroupAssignment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroupAssignment201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignment(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroupAssignment201Response> {
        const response = await this.createUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a user
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.newTaskUserId !== undefined) {
            queryParameters['new_task_user_id'] = requestParameters.newTaskUserId;
        }

        if (requestParameters.newProspectUserId !== undefined) {
            queryParameters['new_prospect_user_id'] = requestParameters.newProspectUserId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user group
     */
    async deleteUserGroupRaw(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group
     */
    async deleteUserGroup(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignmentRaw(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserGroupAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-group-assignments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignment(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissionsRaw(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserDynamicPermissions200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findAllUserDynamicPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}/dynamic-permissions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserDynamicPermissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissions(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserDynamicPermissions200Response> {
        const response = await this.findAllUserDynamicPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccessRaw(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserFacilityAccess200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findAllUserFacilityAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}/facility-access`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserFacilityAccess200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccess(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserFacilityAccess200Response> {
        const response = await this.findAllUserFacilityAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all user groups
     */
    async findAllUserGroupsRaw(requestParameters: FindAllUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserGroups200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserGroups200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user groups
     */
    async findAllUserGroups(requestParameters: FindAllUserGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserGroups200Response> {
        const response = await this.findAllUserGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get All Users
     */
    async findAllUsersV2Raw(requestParameters: FindAllUsersV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUsersV2200Response>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.facilityIds !== undefined) {
            queryParameters['facility_ids'] = requestParameters.facilityIds;
        }

        if (requestParameters.userTypeIds !== undefined) {
            queryParameters['user_type_ids'] = requestParameters.userTypeIds;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.statuses !== undefined) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['user_id'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUsersV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Get All Users
     */
    async findAllUsersV2(requestParameters: FindAllUsersV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUsersV2200Response> {
        const response = await this.findAllUsersV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user by ID
     */
    async findOneUserRaw(requestParameters: FindOneUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneUser200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.includeDeleted !== undefined) {
            queryParameters['include_deleted'] = requestParameters.includeDeleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a user by ID
     */
    async findOneUser(requestParameters: FindOneUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneUser200Response> {
        const response = await this.findOneUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find one user group
     */
    async findOneUserGroupRaw(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneUserGroup.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Find one user group
     */
    async findOneUserGroup(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.findOneUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the currently authenticated user
     */
    async getCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentUser200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the currently authenticated user
     */
    async getCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentUser200Response> {
        const response = await this.getCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get mention suggestions (recent or search)
     */
    async getMentionSuggestionsRaw(requestParameters: GetMentionSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMentionSuggestions200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getMentionSuggestions.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/mentions/suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMentionSuggestions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get mention suggestions (recent or search)
     */
    async getMentionSuggestions(requestParameters: GetMentionSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMentionSuggestions200Response> {
        const response = await this.getMentionSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get MFA settings for the current organization
     */
    async getOrganizationMfaSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationMfaSettings200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organizations/mfa-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationMfaSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get MFA settings for the current organization
     */
    async getOrganizationMfaSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationMfaSettings200Response> {
        const response = await this.getOrganizationMfaSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Record a mention usage for recency tracking
     */
    async recordMentionUsageRaw(requestParameters: RecordMentionUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.recordMentionUsageRequest === null || requestParameters.recordMentionUsageRequest === undefined) {
            throw new runtime.RequiredError('recordMentionUsageRequest','Required parameter requestParameters.recordMentionUsageRequest was null or undefined when calling recordMentionUsage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/mentions/record`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordMentionUsageRequestToJSON(requestParameters.recordMentionUsageRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Record a mention usage for recency tracking
     */
    async recordMentionUsage(requestParameters: RecordMentionUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordMentionUsageRaw(requestParameters, initOverrides);
    }

    /**
     * Reject SSO user
     */
    async rejectSsoUserRaw(requestParameters: RejectSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling rejectSsoUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}/reject`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject SSO user
     */
    async rejectSsoUser(requestParameters: RejectSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectSsoUserRaw(requestParameters, initOverrides);
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissionsRaw(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setUserDynamicPermissions.');
        }

        if (requestParameters.setUserDynamicPermissionsRequest === null || requestParameters.setUserDynamicPermissionsRequest === undefined) {
            throw new runtime.RequiredError('setUserDynamicPermissionsRequest','Required parameter requestParameters.setUserDynamicPermissionsRequest was null or undefined when calling setUserDynamicPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/dynamic-permissions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserDynamicPermissionsRequestToJSON(requestParameters.setUserDynamicPermissionsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissions(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setUserDynamicPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Update current user\'s hospital chat signature
     */
    async updateCurrentUserHospitalChatSignatureRaw(requestParameters: UpdateCurrentUserHospitalChatSignatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCurrentUserHospitalChatSignature200Response>> {
        if (requestParameters.updateCurrentUserHospitalChatSignatureRequest === null || requestParameters.updateCurrentUserHospitalChatSignatureRequest === undefined) {
            throw new runtime.RequiredError('updateCurrentUserHospitalChatSignatureRequest','Required parameter requestParameters.updateCurrentUserHospitalChatSignatureRequest was null or undefined when calling updateCurrentUserHospitalChatSignature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/current/hospital-chat-signature`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCurrentUserHospitalChatSignatureRequestToJSON(requestParameters.updateCurrentUserHospitalChatSignatureRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCurrentUserHospitalChatSignature200ResponseFromJSON(jsonValue));
    }

    /**
     * Update current user\'s hospital chat signature
     */
    async updateCurrentUserHospitalChatSignature(requestParameters: UpdateCurrentUserHospitalChatSignatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCurrentUserHospitalChatSignature200Response> {
        const response = await this.updateCurrentUserHospitalChatSignatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update current user\'s acknowledged Pylon unread-message baseline
     */
    async updateCurrentUserPylonUnreadBaselineRaw(requestParameters: UpdateCurrentUserPylonUnreadBaselineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCurrentUserPylonUnreadBaseline200Response>> {
        if (requestParameters.updateCurrentUserPylonUnreadBaselineRequest === null || requestParameters.updateCurrentUserPylonUnreadBaselineRequest === undefined) {
            throw new runtime.RequiredError('updateCurrentUserPylonUnreadBaselineRequest','Required parameter requestParameters.updateCurrentUserPylonUnreadBaselineRequest was null or undefined when calling updateCurrentUserPylonUnreadBaseline.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/current/pylon-unread-baseline`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCurrentUserPylonUnreadBaselineRequestToJSON(requestParameters.updateCurrentUserPylonUnreadBaselineRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSON(jsonValue));
    }

    /**
     * Update current user\'s acknowledged Pylon unread-message baseline
     */
    async updateCurrentUserPylonUnreadBaseline(requestParameters: UpdateCurrentUserPylonUnreadBaselineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCurrentUserPylonUnreadBaseline200Response> {
        const response = await this.updateCurrentUserPylonUnreadBaselineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update MFA settings for the current organization
     */
    async updateOrganizationMfaSettingsRaw(requestParameters: UpdateOrganizationMfaSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationMfaSettings200Response>> {
        if (requestParameters.updateOrganizationMfaSettingsRequest === null || requestParameters.updateOrganizationMfaSettingsRequest === undefined) {
            throw new runtime.RequiredError('updateOrganizationMfaSettingsRequest','Required parameter requestParameters.updateOrganizationMfaSettingsRequest was null or undefined when calling updateOrganizationMfaSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/organizations/mfa-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationMfaSettingsRequestToJSON(requestParameters.updateOrganizationMfaSettingsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationMfaSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Update MFA settings for the current organization
     */
    async updateOrganizationMfaSettings(requestParameters: UpdateOrganizationMfaSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationMfaSettings200Response> {
        const response = await this.updateOrganizationMfaSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatusRaw(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserCrmNotificationStatus.');
        }

        if (requestParameters.userCrmNotificationStatus === null || requestParameters.userCrmNotificationStatus === undefined) {
            throw new runtime.RequiredError('userCrmNotificationStatus','Required parameter requestParameters.userCrmNotificationStatus was null or undefined when calling updateUserCrmNotificationStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/crm-notifications`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCrmNotificationStatusToJSON(requestParameters.userCrmNotificationStatus),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatus(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserCrmNotificationStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccessRaw(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserFacilityAccess.');
        }

        if (requestParameters.updateUserFacilityAccessRequest === null || requestParameters.updateUserFacilityAccessRequest === undefined) {
            throw new runtime.RequiredError('updateUserFacilityAccessRequest','Required parameter requestParameters.updateUserFacilityAccessRequest was null or undefined when calling updateUserFacilityAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/facility-access`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserFacilityAccessRequestToJSON(requestParameters.updateUserFacilityAccessRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccess(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserFacilityAccessRaw(requestParameters, initOverrides);
    }

    /**
     * Update user group
     */
    async updateUserGroupRaw(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserGroup.');
        }

        if (requestParameters.userGroup === null || requestParameters.userGroup === undefined) {
            throw new runtime.RequiredError('userGroup','Required parameter requestParameters.userGroup was null or undefined when calling updateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters.userGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Update user group
     */
    async updateUserGroup(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.updateUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send verification email for the current user
     */
    async verifyCurrentUserEmailMfaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/current/email-verification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send verification email for the current user
     */
    async verifyCurrentUserEmailMfa(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyCurrentUserEmailMfaRaw(initOverrides);
    }

}
